import React, { useState, useEffect } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    useNotify,
    useRedirect,
    SelectArrayInput, BooleanInput,
} from 'react-admin';


export const OperatorCreate = () => {
    const notify = useNotify();
    const redirect = useRedirect();


    return (
        <Create>
            <SimpleForm >
                <TextInput name="name" source="name" validate={[required()]} fullWidth />
                <TextInput name="host" source="host" validate={[required()]} fullWidth />
                <NumberInput name="availableSlots" source="availableSlots" validate={[required()]} fullWidth />
                <NumberInput name="totalSlots" source="totalSlots" validate={[required()]} fullWidth />
                <TextInput
                    name="token"
                    source="token"
                    validate={[required()]}
                    fullWidth
                    resettable />
                <BooleanInput name="isSystem" source="isSystem" validate={[required()]} />
                {/*<TextInput name="responseToken" source="responseToken" validate={[required()]} fullWidth />*/}
                {/*<NumberInput name="totalProcesses" source="totalProcesses" validate={[required()]} fullWidth />*/}
                {/*<NumberInput name="currentlyUsedProcesses" source="currentlyUsedProcesses" validate={[required()]} fullWidth />*/}
                {/*<SelectArrayInput*/}
                {/*    source="processors"*/}
                {/*    choices={ processors }*/}
                {/*    label="Available Processors"*/}
                {/*    validate={[required()]}*/}
                {/*    style={ { textTransform: 'capitalize' } } />*/}

            </SimpleForm>
        </Create>
    );
}